module.exports = __webpack_public_path__ + "img/soft-skills-image-4.5e23522c.jpg";